import { render } from "./Navigation.vue?vue&type=template&id=79f92daa&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=79f92daa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Chikondi Kamwendo\\Projects\\Vue\\care.malawi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f92daa"]])

export default __exports__